'use strict';
/*@ngInject*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cookies;
function cookies($location, $log) {
  var LOGGER = $log.getInstance('cookies');

  return {

    getAll: function getAll() {
      return $.cookie();
    },

    put: function put(key, value, expires, path, domain, secure) {
      LOGGER.log('put() key:' + key + ' expires:' + expires + ' path:' + path + ' domain:' + domain + ' secure:' + secure);

      if (!expires) {
        $.cookie(key, value, { path: path, domain: domain, secure: secure });
      } else {
        $.cookie(key, value, { expires: expires, path: path, domain: domain, secure: secure });
      }

      LOGGER.log('put() END');
      return $.cookie(key) ? true : false;
    },

    get: function get(key) {
      LOGGER.log('get(' + key + ')');

      var cook = $.cookie(key);
      return typeof cook !== 'undefined' ? cook : "";
    },

    remove: function remove(key, expires, path, domain, secure) {
      LOGGER.log('remove key:' + key + ' expires:' + expires + ' path:' + path + ' domain:' + domain + ' secure:' + secure);

      var val = null;
      if (expires != null) {
        val = $.removeCookie(key, { path: path, domain: domain, secure: secure });
      } else {
        val = $.removeCookie(key, { expires: expires, path: path, domain: domain, secure: secure });
      }

      LOGGER.log('remove() END - val:', val);

      return val;
    }

  };
};


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.services/cookies.js
// module id = 134
// module chunks = 2